import React from 'react';

import {pushInteractionTagManager} from '../../services/tagManager';
import {Logo} from '../../shared/components/Logo';

const Facebook = '/socials/facebook.svg';
const Instagram = '/socials/instagram.svg';
const LinkedIn = '/socials/linkedin.svg';
const Twitter = '/socials/twitter.svg';
const Blog = '/socials/blog.svg';
const Youtube = '/socials/youtube.svg';
import './HomeFooter.style.scss';

export const HomeFooter = () => {
  const footerIcon = {
    screenName: 'credenciamento:home',
    elementType: 'footer:icon:click'
  };

  return (
    <footer className="home-footer">
      <div className="home-footer__content">
        <div className="home-footer__info">
          <div className="home-footer__logo">
            <Logo />
          </div>
          <div className="home-footer__text">
            <p>Todos os direitos reservados.</p>
            <p>Copyright 2022 Alelo</p>
          </div>
        </div>

        <div className="home-footer__contact">
          <div>
            <h3 className="home-footer__title">ACOMPANHE NOSSAS NOVIDADES</h3>
          </div>
          <div className="home-footer__socials">
            <a
              href="https://www.facebook.com/AleloBrasil"
              target="blank"
              data-testid="link-facebook"
              id="link-facebook"
              onClick={() =>
                pushInteractionTagManager({
                  ...footerIcon,
                  elementContent: 'none:facebook:redes-sociais'
                })
              }
            >
              <div>
                <img src={Facebook} alt="Logo do Facebook" />
              </div>
            </a>
            <a
              href="https://twitter.com/alelobrasil"
              target="blank"
              data-testid="link-twitter"
              id="link-twitter"
              onClick={() =>
                pushInteractionTagManager({
                  ...footerIcon,
                  elementContent: 'none:twitter:redes-sociais'
                })
              }
            >
              <div>
                <img src={Twitter} alt="Logo do Twitter" />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/alelo-brasil/?originalSubdomain=br"
              target="blank"
              data-testid="link-linkdin"
              id="link-linkdin"
              onClick={() =>
                pushInteractionTagManager({
                  ...footerIcon,
                  elementContent: 'none:linkedin:redes-sociais'
                })
              }
            >
              <div>
                <img src={LinkedIn} alt="Logo do LinkedIn" />
              </div>
            </a>
            <a
              href="https://www.instagram.com/alelobrasil/"
              target="blank"
              data-testid="link-instagram"
              id="link-instagram"
              onClick={() =>
                pushInteractionTagManager({
                  ...footerIcon,
                  elementContent: 'none:instagram:redes-sociais'
                })
              }
            >
              <div>
                <img src={Instagram} alt="Logo do Instagram" />
              </div>
            </a>
            <a
              href="https://www.youtube.com/alelo"
              target="blank"
              data-testid="link-youtube"
              id="link-youtube"
              onClick={() =>
                pushInteractionTagManager({
                  ...footerIcon,
                  elementContent: 'none:youtube:redes-sociais'
                })
              }
            >
              <div>
                <img src={Youtube} alt="Logo do Youtube" />
              </div>
            </a>
            <a
              href="https://blog.alelo.com.br/?_ga=2.201302126.1104231267.1673359809-669311145.1673359809"
              target="blank"
              data-testid="link-alelo-blog"
              id="link-alelo-blog"
              onClick={() =>
                pushInteractionTagManager({
                  ...footerIcon,
                  elementContent: 'none:blog-alelo:redes-sociais'
                })
              }
            >
              <div>
                <img src={Blog} alt="Logo do Blog Alelo" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
